/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, enumeration, identity, subentity } from '@gh/core-data';

import { MasterZoneListItemMapper } from '../../master-zones';
import { Month, OfficeDetailsDto } from '../models/office-details.dto';
import { OfficeMeasurementDefault } from '../models/office-measurement-default.enum';
import { OfficeMeasurement } from '../models/office-measurement.enum';
import { OfficeStatus } from '../models/office-status.enum';
import { OfficeType } from '../models/office-type.enum';
import { OfficeListItemMapper } from './office-list-item.mapper';

export const OfficeDetailsMapper = entity<OfficeDetailsDto>({
  type: enumeration(OfficeType),
  status: enumeration(OfficeStatus),
  masterZone: MasterZoneListItemMapper,
  formedDate: date(DateFormat.Date),
  measurement: enumeration(OfficeMeasurement),
  measurementDefault: enumeration(OfficeMeasurementDefault),
  sourceOffice: OfficeListItemMapper,
  conversionDate: date(DateFormat.Date),
  lastMonthFinYear: enumeration(Month),
  billing: subentity<any>({
    contractSignedDate: date(DateFormat.Date),
    depositDate: date(DateFormat.Date),
    originalCommencement: date(DateFormat.Date),
    currentAgreement: date(DateFormat.Date),
    renewalDate: date(DateFormat.Date),
    officeClosed: date(DateFormat.Date),
    onSellDate: date(DateFormat.Date),
  }),
  unpaidInvoices: arrayOf(identity()),
});
